import { ContactForm } from "./ContactForm.tsx";
import Link from "./Link.tsx";
import { PageSlider } from "./PagesSlider.tsx";
import { BenefitCard, Benefits, } from "./sections/BenifitsSection.tsx";
import { Blogs } from "./sections/Blogs.tsx";
import { Box, Boxes } from "./sections/Boxes.tsx";
import { ButtonCTA } from "./sections/ButtonCTA.tsx";
import { Card, Cards, WideCard } from "./sections/Cards.tsx";
import { ContactCTA } from "./sections/ContactCTA.tsx";
import { Content, Details, Summary } from "./sections/DetailsSummary.tsx";
import { GTLogo } from "./sections/GTLogo.tsx";
import { HeroSection } from "./sections/HeroSection.tsx";
import { HomeSlider } from "./sections/HomeSlider.tsx";
import { Location, Locations } from "./sections/LocationsSection.tsx";
import { AllLogos, Logo, Logos } from "./sections/Logos.tsx";
import { ItemWithIcon, ItemWithIconGrid } from "./sections/ItemWithIcon.tsx";
import { Section, SectionSubtitle } from "./sections/Section.tsx";
import { CollapsibleCard } from "./sections/CollapsibleCard.tsx";
import { Stories, Story, } from "./sections/Stories.tsx";
import { FeatureCard, FeatureCardIcon, FeatureCardContent } from "./sections/FeatureCard.tsx";
import {
  FeatureSection,
  FeatureTitle,
  FeatureContent,
  FeatureDescription,
  FeatureLeadText,
  FeatureHighlight,
  FeaturePoints,
  FeaturePoint,
  FeatureValues,
  FeatureVisual
} from "./sections/FeatureSection.tsx";
import {
  BenefitItem,
  BenefitIcon,
} from "./sections/BenefitSection.tsx";
import { Grid, Flex } from "./sections/LayoutComponents.tsx";
import {
  CTASection,
  CTAButtons
} from "./sections/CTASection.tsx";
import { LeadingPartners } from "./sections/LeadingPartners.tsx";
import { OutcomeCard, OutcomeCards } from "./sections/OutcomeCards.tsx";
import { ExperienceCard, ExperienceCards } from "./sections/ExperienceCard.tsx";
import { ValueCard, ValueCards } from "./sections/ValueCard.tsx";
import { CenteredContent } from "./sections/CenteredContent.tsx";
import {
  LineIcon,
  PotsAlertBar,
  PotsEyebrow,
  PotsHero,
  PotsContentSplit,
  PotsSystemTags,
  PotsSystemTag,
  PotsCards,
  PotsCard,
  PotsFramework,
  PotsCallout,
  PotsStepsSection,
  PotsStep,
  PotsQuote
} from "./sections/PotsComponents.tsx";
import { StatBar, Stat } from "./sections/StatBar.tsx";
import { PromoCard } from "./sections/PromoCard.tsx";
import { Web3ContactForm } from "./Web3ContactForm.tsx";
import { PartyRegistrationForm } from "./PartyRegistrationForm.tsx";
import {
  VSHero,
  VSFeaturedVideo,
  VSOverview,
  VSVideoGrid,
  VSVideoCard
} from "./sections/VideoSeriesComponents.tsx";

export const components = {
  HeroSection,
  HomeSlider,
  Logo,
  Logos,
  Story,
  Stories,
  ButtonCTA,
  Benefits,
  BenefitCard,
  ContactForm,
  Locations,
  Location,
  Section,
  SectionSubtitle,
  Blogs,
  PageSlider,
  AllLogos,
  ItemWithIcon,
  ItemWithIconGrid,
  Link,
  Boxes,
  Box,
  Details,
  Summary,
  Content,
  GTLogo,
  ContactCTA,
  Cards,
  Card,
  WideCard,
  CollapsibleCard,
  FeatureCard,
  FeatureCardIcon,
  FeatureCardContent,
  FeatureSection,
  FeatureTitle,
  FeatureContent,
  FeatureDescription,
  FeatureLeadText,
  FeatureHighlight,
  FeaturePoints,
  FeaturePoint,
  FeatureValues,
  FeatureVisual,
  Grid,
  Flex,
  BenefitItem,
  BenefitIcon,
  CTASection,
  CTAButtons,
  LeadingPartners,
  ExperienceCard,
  ExperienceCards,
  ValueCard,
  ValueCards,
  CenteredContent,
  PotsAlertBar,
  PotsEyebrow,
  Eyebrow: PotsEyebrow,
  PotsHero,
  PotsContentSplit,
  PotsSystemTags,
  PotsSystemTag,
  PotsCards,
  PotsCard,
  PotsFramework,
  PotsCallout,
  PotsStepsSection,
  PotsStep,
  PotsQuote,
  StatBar,
  Stat,
  PromoCard,
  OutcomeCards,
  OutcomeCard,
  LineIcon,
  Web3ContactForm,
  PartyRegistrationForm,
  VSHero,
  VSFeaturedVideo,
  VSOverview,
  VSVideoGrid,
  VSVideoCard
};
